



















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as XLSX from 'xlsx';
import { IExcelSheetHeader } from './store/ImporterStore';

interface ISheetErrors {
  missingHeaders: string;
}

interface ISheetHeader {
  text: string;
  value: string;
  sortable: boolean;
  missingHeader: string;
}

@Component
export default class SheetPreview extends Vue {

  @Prop({ required: true, default: () => null }) private sheet: XLSX.WorkSheet | null;

  @Watch('sheet', { immediate: true }) onSheetChanged() {
    this.sheetHeaders = this.getSheetHeaders();
  }

  get sheetHeaders() {
    return this.$store.state.importer.excelSheetHeaders;
  }

  set sheetHeaders(headers: IExcelSheetHeader[]) {
    this.$store.commit('importer/setExcelSheetHeaders', headers);
  }

  get rows() {
    return this.$store.state.importer.rowData;
  }

  set rows(rowData: any[]) {
    this.$store.commit('importer/setRowData', rowData);
  }

  getSheetHeaders(): IExcelSheetHeader[] {
    const sheet = this.sheet;

    if (!sheet || !sheet['!ref']) {
      return [];
    }

    const range = XLSX.utils.decode_range((sheet as any)['!ref']);
    const headers = [];
    for (let i = range.s.c; i <= range.e.c; i++) {
      const columnLetter = this.getColumnAsLetters(i);
      const rowNumber = range.s.r + 1;
      const cell = (sheet as any)[`${columnLetter}${rowNumber}`];
      // let value = `${columnLetter}: `;
      let value = ``;
      if (typeof cell !== 'undefined') {
        if (typeof cell.v === 'string') {
          value += cell.v.trim();
        } else {
          value += cell.w;
        }
      }
      const header = {
        text: `${columnLetter}: ${value}`,
        value: columnLetter,
        sortable: false,
        missingHeader: !value ? '' : columnLetter,
        width: '1000px',
      };

      headers.push(header);
    }
    return headers.filter(x => x);
  }

  get sheetErrors(): ISheetErrors {
    const missingHeaders = this.sheetHeaders
      .filter(sh => !sh.missingHeader)
      .map(sh => sh.text.replace(':', '').trim())
      .join(', ');
    return { missingHeaders };
  }

  getColumnAsLetters(column: number) {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const firstLetter = Math.floor(column / alphabet.length);
    return firstLetter <= 0 ? alphabet[column] : alphabet[firstLetter - 1] + alphabet[column - 26 * firstLetter];
  }

}
